export const TQL_TERMS_URL = "https://www.tql.com/terms";
export const TQL_PRIVACY_POLICY_URL = "https://www.tql.com/privacy";
